module.exports = __webpack_public_path__ + "static/features-human-66fe9b7abe3d475cab18c648341d0875.png";